import { useNavigate } from 'react-router-dom'
import PageProtocol from '@/components/PageProtocol'
import { usePageMeta } from '@/hooks/usePageMeta'

export default function PageProtocoloDetalhe() {
  const navigate = useNavigate()

  usePageMeta({
    title: 'Protocolo de Liberação e Cocriação — Reative os 4 Elementos',
    description:
      'Enquanto você dorme, suas dores mais antigas estão sendo liberadas, uma por uma. Uma sessão de liberação gravada em áudio exclusivamente para você, em 6 ciclos de 21 dias.',
    ogImage: 'https://static.lumi.new/2a/2ae8843245193092a9f2a8f148dea3ad.svg',
    ogUrl: 'https://jornada.reacendaluz.com.br/protocolo/',
  })

  return (
    <main className="min-h-screen w-full pt-12 pb-24 md:pt-16 md:pb-28">
      <PageProtocol onBack={() => navigate('/ofertas/')} />
    </main>
  )
}
